export function buildDocBuilderHref(args: {
  dealId: string;
  packageId: string;
  collectionId: string;
  isTemplate?: boolean;
}): string {
  const base = args.isTemplate ? '/templates' : '/deals';
  const qs = new URLSearchParams({
    builderMode: 'build',
    doc: args.collectionId,
  });
  return `${base}/${args.dealId}/packages/${args.packageId}/docs?${qs.toString()}`;
}

/** Parses `?doc=` from a doc-builder href produced by {@link buildDocBuilderHref}. */
export function parseDocBuilderCollectionId(href: string): string | null {
  try {
    const url = new URL(href, 'http://localhost');
    return url.searchParams.get('doc');
  } catch {
    return null;
  }
}
